import { render, staticRenderFns } from "./PlaylistCRUD.vue?vue&type=template&id=e892a98a&scoped=true"
import script from "./PlaylistCRUD.vue?vue&type=script&lang=ts"
export * from "./PlaylistCRUD.vue?vue&type=script&lang=ts"
import style0 from "./PlaylistCRUD.vue?vue&type=style&index=0&id=e892a98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e892a98a",
  null
  
)

export default component.exports